@if(section){
<h5>{{section.title}}</h5>
<ul class="nav nav-pills" [class.show-images]="section.showImages">
  @for (tab of section.tabs; track tab.id; let i = $index) {
  <li class="nav-item">
    <button class="btn btn-link" [routerLink]="tab.routerLink"
      routerLinkActive="active">
      @if(section.showImages){
      <div class="img-wrapper">
        <app-asset [assetId]="tab.assetId"></app-asset>
      </div>
      }
      <div class="text">
        {{tab.name}}
      </div>
    </button>
  </li>
  }
</ul>
}
